import type { RoleType } from '../type';

type GroupType = { [key: string]: RoleType[] };

const groupRoles = (roles:RoleType[]) => roles.reduce((acc: GroupType, item) => {
  const parts = item.id.split('_');
  const category = parts[parts.length - 1];

  if (!acc[category]) {
    acc[category] = [];
  }

  acc[category].push(item);

  return acc;
}, {});

export default groupRoles;
